<template>
  <router-view v-slot="{ Component }">
    <keep-alive>
      <component :is="Component" />
    </keep-alive>
  </router-view>
</template>

<style lang="scss">
@import "@/assets/font/font.css";
@import '@/assets/css/common.css';

// 根元素字体大小
html {
  font-size: 16px;
}

// 全局字体
#app {
  //font-family: "alimother";
  //font-family: "Microsoft YaHei", unset, serif;
  font-family: "Medium", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

// 全局缩小
.safe-area {
  width: 80% !important;
  margin: 0 auto;
  padding: 40px 0;
}

// 基本颜色
:root {
  --common-color: #00aeef; // 页面的通用颜色
  --gray-color: #8d8d8d; // 小标题的字体颜色
  --white-color: #f7f9fa; // 大板块的背景颜色
  --start-color: #75d5f9; // 渐变起始颜色
  --new-bgColor1: #E1E1E1; // 最新版的背景颜色1
  --new-bgColor2: #252B42; // 最新版的背景颜色2
  --new-btnColor: #23A6F0; // 最新版部分按钮的背景颜色
}

// 动画效果
.slide-down-enter-active {
  animation: slideDownIn 0.5s ease-out;
}

.slide-down-leave-active {
  animation: slideDownOut 0.5s ease-in;
}

@keyframes slideDownIn {
  from {
    transform: translateY(-30px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

@keyframes slideDownOut {
  from {
    transform: translateY(0);
    opacity: 1;
  }
  to {
    transform: translateY(-30px);
    opacity: 0;
  }
}

</style>
